import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopItemsService } from '@/modules/shop/api/services'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import type { paths } from '@/schema'

type CreateShopItemBody =
	paths['/api/admin/shop/items']['post']['requestBody']['content']['application/json']
type CreateShopItemResponse =
	paths['/api/admin/shop/items']['post']['responses']['201']['content']['application/json']

const useMutationCreateShopItem = () => {
	const queryClient = useQueryClient()

	return useMutation<CreateShopItemResponse, Error, CreateShopItemBody>({
		mutationFn: (data) => ShopItemsService.createShopItem(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SHOP_QUERY_KEYS.ITEMS.ALL })
			toast.success('สร้างสินค้าสำเร็จ')
		},
		onError: (error) => {
			console.error('Create shop item error:', error)
			showErrorToast(error)
		},
	})
}

export default useMutationCreateShopItem
